module.exports = __webpack_public_path__ + "img/bg_1.c0d80a25.png";